import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {SidebarService} from './sidebar.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {BoardsService} from "@components/boards/boards.service";
import {ToastrService} from "ngx-toastr";
import {NewBoardComponent} from "@components/boards/new-board/new-board.component";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ProjectsService} from "@components/projects/projects.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    animations: [
        trigger('slide', [
            state('up', style({height: 0})),
            state('down', style({height: '*'})),
            transition('up <=> down', animate(200))
        ])
    ]
})
export class SidebarComponent implements OnInit, OnDestroy {
    public isExpanded = true;
    showSubmenu: boolean = false;
    isShowing = false;
    showSubSubMenu: boolean = false;

    sidebarSubscription: Subscription;
    newBoardCreated: Subscription;


    menuItems = [];
    boards = [];
    searchText = '';
    loader: boolean;


    constructor(
        private sidebarservice: SidebarService,
        public matDialog: MatDialog,
        private boardsService: BoardsService,
        private router: Router,
        private projectsService: ProjectsService
    ) {
    }


    ngOnDestroy(): void {
        this.sidebarSubscription.unsubscribe();
        this.newBoardCreated.unsubscribe();
    }

    ngOnInit() {
        this.sidebarSubscription = this.sidebarservice.sidebarBS.subscribe((result: boolean) => {
            this.isExpanded = result;
        });
        this.loader = true;
        this.getUserBoards();
        this.menuItems = this.sidebarservice.getMenuList();
    }

    mouseenter() {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;

        }
    }

    //index u menuItems
    filter(filterArray: any[], index) {
        this.menuItems = this.sidebarservice.getMenuList();
    }


    createNewTask() {
        this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'new',
                task: null,
                sort: 'task'

            }
        });
    }

    getState(currentMenu) {

        if (currentMenu.active) {
            return 'down';
        } else {
            return 'up';
        }
    }

    hasBackgroundImage() {
        return this.sidebarservice.hasBackgroundImage;
    }

    public getSidebarState() {
        return this.isExpanded;
    }


    addNewBoard() {
        const openModalBoard = this.matDialog.open(NewBoardComponent, {
            position: {top: '50'},
            autoFocus: true,
            hasBackdrop: false,
            maxHeight: '67%',
        }).afterClosed().subscribe(result => {
            if (result === true) {
                this.getUserBoards();
            }
        });
    }

    getUserBoards() {

        this.boardsService.getUserBoards().subscribe((responseData: BackendResponse) => {
            if (responseData.type === 'success') {
                this.boards = responseData.data;
                this.sidebarservice.setSideBarBoards(this.boards);
                this.loader = false;
                this.menuItems = this.sidebarservice.getMenuList();
            }
        });
    }

    navigateTo(route: string) {
        if (route !== '' && route) {
            this.router.navigateByUrl(route);
        }
    }

    subitemHandler(subItem: { name: string, hasFunction: boolean, _id: string, link: '' }) {
        if (subItem.hasFunction) {
            if (subItem['function'] === 'addNewBoard') {
                this.addNewBoard();
            }
        } else {
// za sad stoji ovako jer imamo samo boardove za izlistavanje
            this.router.navigate(['/board/' + subItem._id]);
        }

    }

    closeSidebar() {
        this.sidebarservice.sidebarBS.next(!this.sidebarservice.sidebarBS.getValue());

    }

    get bboards() {
        return this.boards;
    }


}

